import * as Factory from 'factory.ts'
import faker from 'faker'

import { type IntegrationStatusConstructor } from './IntegrationStatus'

export const IntegrationStatusConstructorFactory =
  Factory.Sync.makeFactory<IntegrationStatusConstructor>({
    integrationConnections: {
      netsuiteV2: faker.random.boolean(),
      punchout: faker.random.boolean(),
      quickbooks: faker.random.boolean(),
      quickbooksOnline: faker.random.boolean(),
      slack: faker.random.boolean(),
    },
    slackIntegration: {
      slackRedirectUrl: faker.random.word(),
      slackState: faker.random.word(),
      slackClientId: faker.random.word(),
    },
  })
